import { NewButtonProps as ButtonProps } from './types'
import styled from 'styled-components'
import { CommonButton } from '@/ui/LegacyButton'

export const Button = (props: ButtonProps) => {
  const { startIcon, children, ...rest } = props
  return (
    <ButtonStyled {...rest}>
      {startIcon}
      {children}
    </ButtonStyled>
  )
}

const ButtonStyled = styled(CommonButton)`
  align-items: center;
`
